import type { SVGAttributes } from 'react';

type PrescriptionPagePillIconProps = SVGAttributes<SVGSVGElement> & {
  title?: string;
};

/** Document with text lines and a capsule — matches the compra-com-receita CTA mock. */
export function PrescriptionPagePillIcon({
  title,
  width = 24,
  height = 24,
  ...props
}: Readonly<PrescriptionPagePillIconProps>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {/* Page outline */}
      <path
        d="M5.75 3.5h9.1L18.25 7v12.75a1.25 1.25 0 0 1-1.25 1.25H5.75A1.25 1.25 0 0 1 4.5 19.75V4.75A1.25 1.25 0 0 1 5.75 3.5Z"
        stroke="currentColor"
        strokeWidth="1.55"
        strokeLinejoin="round"
      />
      {/* Folded corner */}
      <path
        d="M14.85 3.5V6.4c0 .5.4.9.9.9h2.5"
        stroke="currentColor"
        strokeWidth="1.55"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Text lines — leave space for capsule */}
      <path
        d="M7.4 9.75h7.2M7.4 12.5h5.6M7.4 15.25h3.4"
        stroke="currentColor"
        strokeWidth="1.45"
        strokeLinecap="round"
      />
      {/* Capsule overlaid on bottom-right of the page */}
      <g transform="translate(12.4 14.6) rotate(-32)">
        <rect width="8.4" height="4" rx="2" fill="currentColor" />
        <path
          d="M4.2 0v4"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          opacity="0.45"
        />
      </g>
    </svg>
  );
}
